import { useState } from "react";
import "./Hero.css";

const LOCATIONS = ["Coimbatore", "Mettupalayam", "Ooty", "Coonoor", "Bangalore", "Mysuru", "Salem", "Chennai", "Kotagiri"];

export default function Hero() {
  const [dest, setDest] = useState("Ooty");
  const [pickup, setPickup] = useState("Coimbatore");
  const [drop, setDrop] = useState("Ooty");
  const [pkg, setPkg] = useState("Family & Friends");
  const [duration, setDuration] = useState("2D / 1N");
  const [members, setMembers] = useState(2);
  const [date, setDate] = useState("");

  const search = () => {
    const msg = `Hi OotyGo! I'd like to plan a trip.\n• Destination: ${dest}\n• Pickup: ${pickup}\n• Drop: ${drop}\n• Package: ${pkg}\n• Plan: ${duration}\n• Members: ${members}${date ? `\n• Travel date: ${date}` : ""}\nPlease share availability & a quote.`;
    window.open(`https://wa.me/919655062118?text=${encodeURIComponent(msg)}`, "_blank");
  };

  return (
    <header className="hero" id="home">
      <div className="hero-bg" />
      <div className="hero-overlay" />
      <span className="hero-blob b1" />
      <span className="hero-blob b2" />

      <div className="hero-inner">
        <span className="hero-eyebrow">🌿 Queen of the Nilgiris</span>

        <h1 className="hero-title">
          Discover <span className="hero-grad">Ooty</span> the
          <br /> effortless way
        </h1>

        <p className="hero-sub">
          Curated tour packages, trusted cabs &amp; handpicked hill-view stays —
          booked in minutes, crafted by locals who know every misty trail.
        </p>

        {/* Glass quick-search booking widget */}
        <div className="hero-search">
          <div className="hs-grid">
            <div className="hs-field">
              <label>📍 Destination</label>
              <select value={dest} onChange={(e) => setDest(e.target.value)}>
                <option>Ooty</option><option>Coonoor</option><option>Pykara</option>
                <option>Kotagiri</option><option>Mudumalai</option><option>Avalanche</option>
              </select>
            </div>
            <div className="hs-field">
              <label>🚐 Pickup</label>
              <select value={pickup} onChange={(e) => setPickup(e.target.value)}>
                {LOCATIONS.map((l) => <option key={l}>{l}</option>)}
              </select>
            </div>
            <div className="hs-field">
              <label>🏁 Drop</label>
              <select value={drop} onChange={(e) => setDrop(e.target.value)}>
                {LOCATIONS.map((l) => <option key={l}>{l}</option>)}
              </select>
            </div>
            <div className="hs-field">
              <label>🧳 Package</label>
              <select value={pkg} onChange={(e) => setPkg(e.target.value)}>
                <option>Family &amp; Friends</option><option>Couples</option>
                <option>Private Group</option><option>Customizable</option>
              </select>
            </div>
            <div className="hs-field">
              <label>🗓️ Plan</label>
              <select value={duration} onChange={(e) => setDuration(e.target.value)}>
                <option>1 Day Trip</option><option>2D / 1N</option><option>3D / 2N</option>
                <option>4D / 3N</option><option>5D / 4N</option>
              </select>
            </div>
            <div className="hs-field">
              <label>👥 Members</label>
              <input type="number" min="1" max="60" value={members} onChange={(e) => setMembers(e.target.value)} />
            </div>
            <div className="hs-field">
              <label>📅 Travel date</label>
              <input type="date" value={date} onChange={(e) => setDate(e.target.value)} />
            </div>
          </div>
          <button className="hs-btn" onClick={search}>Check Availability</button>
        </div>

        <div className="hero-cta">
          <a href="#packages" className="hero-btn primary">Explore Packages</a>
          <a href="#cab" className="hero-btn ghost">🚕 Book a Cab</a>
        </div>

        <div className="hero-stats">
          <div className="hero-stat"><b>4.9★</b><span>Google rating</span></div>
          <div className="hero-divider" />
          <div className="hero-stat"><b>10k+</b><span>Happy travelers</span></div>
          <div className="hero-divider" />
          <div className="hero-stat"><b>50+</b><span>Sightseeing spots</span></div>
        </div>
      </div>

      <a href="#about" className="hero-scroll" aria-label="Scroll down">
        <span className="mouse"><span className="wheel" /></span>
      </a>
    </header>
  );
}
